import { Grid, InputAdornment } from '@mui/material'
import { FormField } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import Dialog from 'global/guides/Dialog'
import { useValeAlimentacaoOutletContext } from 'pages/RelatorioValeAlimentacao'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
    ValeAlimentacao,
    createValeAlimentacaoSchema,
    valeAlimentacao,
    valoresValeAlimentacao,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

export default function ConfiguracaoValeAlimentacao() {
    const [searchParam] = useSearchParams()
    const navigate = useNavigate()
    const empresaId = useStore(state => state.companyId)
    const { mutate: createConfig } = valeAlimentacao.mutations.useCreate({
        invalidateQuery: true,
    })
    const { mutate: updateConfig } = valeAlimentacao.mutations.useUpdate({
        invalidateQuery: true,
    })

    function handleClose() {
        const voltar = searchParam.get('voltar')
        if (voltar) navigate(voltar)
        else navigate(-1)
    }

    const {
        Config: { data: configuracao },
    } = useValeAlimentacaoOutletContext()

    function handleSubmit(data: ValeAlimentacao) {
        const callbacks = {
            onSuccess: async () => {
                await valoresValeAlimentacao.invalidateQueries()
                toast.success(
                    `Configuração ${
                        configuracao ? 'atualizada' : 'cadastrada'
                    } com sucesso`,
                )
                handleClose()
            },
            onError: (err: any) => {
                toast.error(err.message)
            },
        }

        if (configuracao) {
            updateConfig(
                {
                    ...data,
                    id: configuracao.id,
                },
                callbacks,
            )
        } else {
            createConfig(data, callbacks)
        }
    }

    return (
        <Dialog.Root
            onClose={handleClose}
            height="auto"
            width="26rem"
            onSubmit={handleSubmit}
            schema={createValeAlimentacaoSchema}
            defaultValues={{
                empresaId,
                ...configuracao,
            }}
        >
            <Dialog.Title>
                {configuracao
                    ? 'Editar configuração'
                    : 'Cadastrar configuração'}
            </Dialog.Title>
            <Dialog.Content dividers>
                <Grid container columnSpacing={2} columns={32}>
                    <Grid item xs={32}>
                        <FormField
                            name="valorVale"
                            label="Valor do vale alimentação"
                            placeholder='Ex: "50.00"'
                            type="number"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        R$
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <IconeAjuda>
                                        É o valor integral do vale alimentação
                                        que o funcionário receberá caso trabalhe
                                        o número de horas mínimo.
                                    </IconeAjuda>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={16}>
                        <FormField
                            name="minimoHorasValorIntegral"
                            label="Horas mínimas"
                            type="number"
                            placeholder='Ex: "6"'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                endAdornment: (
                                    <IconeAjuda>
                                        É o valor mínimo de horas que o
                                        funcionário deve trabalhar para receber
                                        o valor integral do vale alimentação.
                                        Caso o funcionário trabalhe menos do que
                                        esse valor, ele receberá o valor
                                        proporcional a porcentagem mínima.
                                    </IconeAjuda>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={16}>
                        <FormField
                            name="maximoHorasValorIntegral"
                            label="Horas máximas"
                            type="number"
                            placeholder='Ex: "8"'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                endAdornment: (
                                    <IconeAjuda>
                                        É o valor máximo de horas que o
                                        funcionário deve trabalhar para receber
                                        o valor integral do vale alimentação.
                                        Caso o funcionário trabalhe mais do que
                                        esse valor, ele receberá o valor
                                        proporcional a porcentagem máxima.
                                    </IconeAjuda>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={16}>
                        <FormField
                            name="porcentagemValorMinimo"
                            label="Porcentagem mínima"
                            type="number"
                            placeholder='Ex: "50"'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                endAdornment: (
                                    <IconeAjuda>
                                        É a porcentagem mínima que o funcionário
                                        receberá caso trabalhe menos do que o
                                        número de horas mínimo.
                                    </IconeAjuda>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={16}>
                        <FormField
                            name="porcentagemValorMaximo"
                            label="Porcentagem máxima"
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder='Ex: "120"'
                            InputProps={{
                                endAdornment: (
                                    <IconeAjuda>
                                        É a porcentagem máxima que o funcionário
                                        receberá caso trabalhe mais do que o
                                        número de horas máximo.
                                    </IconeAjuda>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
